import React, { useState, useEffect } from "react";
import Header from "../../components/header";
import History from "../../components/history";
import styles from "./InventarioInicial.module.css";
import { Table, Row, Col, Form, Button } from "react-bootstrap";
import { NumericFormat } from "react-number-format";
import { format } from "../../core/number";
import { useCookies } from "react-cookie";
import Notifications, { notify } from "react-notify-toast";
import axios from "axios";

const InventarioInicial = (props) => {
  const { embedded = false, year: propYear } = props;
  const [cookie] = useCookies(["kUserSession"]);
  const [loading, setLoading] = useState(false);
  const [inventory, setInventory] = useState([]);
  const [year, setYear] = useState(propYear ?? new Date().getFullYear());
  const [preview, setPreview] = useState([]);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [snapshotId, setSnapshotId] = useState(null);
  const [periodOpen, setPeriodOpen] = useState(false);

  const history = [
    { name: "Inicio", path: "/" },
    { name: "Movimientos de hacienda", path: "/movimientos" },
  ];

  const prepareHeaders = () => {
    return {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        api_key: "k-randa",
        access_token: cookie.kUserSession.data.access_token,
      },
    };
  };

  const retrievePreview = () => {
    setLoadingPreview(true);
    const currentFarm = cookie.kUserSession.data["farm"];
    const url =
      "inventario_snapshot/preview?id_estancia=" +
      currentFarm.id +
      "&anho=" + year;
    axios
      .get(process.env.REACT_APP_API_URL + url, prepareHeaders())
      .then((rs) => {
        if (rs.status === 200) {
          setPreview(rs.data);
        } else {
          setPreview([]);
        }
        setLoadingPreview(false);
      })
      .catch((err) => {
        console.error(err);
        setPreview([]);
        setLoadingPreview(false);
      });
  };

  const retrievePeriodo = () => {
    const currentFarm = cookie.kUserSession.data["farm"];
    const url = `periodos/${year}/${currentFarm.id}`;
    axios
      .get(process.env.REACT_APP_API_URL + url, prepareHeaders())
      .then((rs) => {
        if (rs.status === 200) {
          setPeriodOpen(rs.data?.estado === "ABIERTO");
        } else {
          setPeriodOpen(false);
        }
      })
      .catch(() => setPeriodOpen(false));
  };

  const handleChange = (idx, field, value) => {
    setPreview((prev) => {
      const data = [...prev];
      const item = { ...data[idx] };
      if (field === "pesoProm") {
        item.pesoTotal = parseFloat(value || 0) * item.existencia;
      } 
      else if (field === "pesoTotal") {
        item.pesoTotal = parseFloat(value || 0);
      }
      data[idx] = item;
      return data;
    });
  };

  const confirmSnapshot = () => {
    setConfirmLoading(true);
    const currentFarm = cookie.kUserSession.data["farm"];
    console.log(preview);
    const body = {
      data: {
        anho: year,
        idEstancia: currentFarm.id,
        tipo: "INICIAL",
        items: preview.map((i) => ({
          categoriaId: i.idCategoria,
          carimbo: i.carimbo,
          cantidad: i.existencia,
          pesoTotal: i.pesoTotal,
          pesoPromedio: i.pesoTotal / i.existencia
        })),
      },
    };
    axios
      .post(
        process.env.REACT_APP_API_URL + "inventario_snapshot",
        body,
        prepareHeaders()
      )
      .then(() => {
        setConfirmLoading(false);
        notify.show("Inventario inicial confirmado", "success");
        retrieve();
      })
      .catch((err) => {
        console.error(err);
        setConfirmLoading(false);
        notify.show("Ocurrió un error al confirmar", "error");
      });
  };

  const retrieve = () => {
    setLoading(true);
    const currentFarm = cookie.kUserSession.data["farm"];
    const url =
      "inventario_snapshot?tipo=INICIAL&id_estancia=" +
      currentFarm.id +
      "&anho=" + year;
    axios
      .get(process.env.REACT_APP_API_URL + url, prepareHeaders())
      .then((rs) => {
        if (
          rs.status === 200 &&
          rs.data &&
          rs.data.data
        ) {
          const data = rs.data.data;
          if (data.items && data.items.length > 0) {
            setInventory(data.items);
            setPreview([]);
            setSnapshotId(data.id);
          } else {
            setInventory([]);
            setSnapshotId(null);
            retrievePreview();
          }
        } else {
          setInventory([]);
          setSnapshotId(null);
          retrievePreview();
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setInventory([]);
        setSnapshotId(null);
        setLoading(false);
        retrievePreview();
      });
  };

  const deleteSnapshot = () => {
    if (!snapshotId) return;
    axios
      .delete(
        process.env.REACT_APP_API_URL + `inventario_snapshot/${snapshotId}`,
        prepareHeaders()
      )
      .then(() => {
        notify.show("Inventario eliminado", "success");
        setInventory([]);
        setSnapshotId(null);
        retrievePreview();
      })
      .catch((err) => {
        console.error(err);
        notify.show("Ocurrió un error al eliminar", "error");
      });
  };

  useEffect(() => {
    retrieve();
    retrievePeriodo();
  }, []);

  useEffect(() => {
    if (propYear !== undefined) {
      setYear(propYear);
    }
  }, [propYear]);

  useEffect(() => {
    retrieve();
    retrievePeriodo();
  }, [year]);

  const previewTotals = preview.reduce(
    (acc, cur) => ({
      cantidad: acc.cantidad + (parseFloat(cur.existencia) || 0),
      peso: acc.peso + (parseFloat(cur.pesoTotal) || 0),
    }),
    { cantidad: 0, peso: 0 }
  );
  const previewPromedio =
    preview.length > 0
      ? preview.reduce((acc, cur) => {
          const cantidad = parseFloat(cur.existencia) || 0;
          const peso = parseFloat(cur.pesoTotal) || 0;
          return acc + (cantidad > 0 ? peso / cantidad : 0);
        }, 0) / preview.length
      : 0;

  const inventoryTotals = inventory.reduce(
    (acc, cur) => ({
      cantidad: acc.cantidad + (parseFloat(cur.cantidad) || 0),
      peso: acc.peso + (parseFloat(cur.pesoTotal) || 0),
    }),
    { cantidad: 0, peso: 0 }
  );
  const inventoryPromedio =
    inventory.length > 0
      ? inventory.reduce((acc, cur) => {
          const cantidad = parseFloat(cur.cantidad) || 0;
          const peso = parseFloat(cur.pesoTotal) || 0;
          return acc + (cantidad > 0 ? peso / cantidad : 0);
        }, 0) / inventory.length
      : 0;

  return (
    <>
      <Notifications />
      {!embedded && <Header history={props.history} />}
      <section className={styles.body}>
        {!embedded && (
          <Row>
            <Col>
              <History
                items={history}
                current={"Inventario inicial"}
                history={props.history}
              />
            </Col>
          </Row>
        )}
        <Row>
          {!embedded && (
            <Col md={2} xs={12}>
              <section className={styles.side}>
                <Form className={styles.searchForm}>
                  <Form.Group>
                    <Form.Label htmlFor="periodo" className={styles.label}>
                      Periodo
                    </Form.Label>
                    <Form.Control
                      id="periodo"
                      className="karanda-input"
                      value={year}
                      onChange={(e) => setYear(e.target.value)}
                      type="number"
                    />
                  </Form.Group>
                </Form>
              </section>
            </Col>
          )}
          <Col>
            <section className={styles.content}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "1rem",
                  alignItems: "center",
                }}
              >
                <h1 className={styles.title}>
                  Inventario inicial periodo {year - 1}/{year}
                </h1>
                {snapshotId && periodOpen && (
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={deleteSnapshot}
                  >
                    Eliminar
                  </Button>
                )}
              </div>
              {loading ? (
                <span>Cargando...</span>
              ) : inventory.length === 0 ? (
                loadingPreview ? (
                  <span>Cargando...</span>
                ) : preview.length > 0 ? (
                  <>
                    <Table
                      bordered
                      hover
                      responsive
                      className="karanda-table"
                    >
                      <thead>
                        <tr>
                          <th>Categoría</th>
                          <th>Cantidad</th>
                          <th>Peso prom.</th>
                          <th>Peso total</th>
                      </tr>
                    </thead>
                    <tbody>
                    {preview.map((i, idx) => (
                      <tr key={idx}>
                        <td>{i.nombre + (i.carimbo ? ' CO' + i.carimbo : '')}</td>
                        <td>{i.existencia}</td>
                        <td>
                          <NumericFormat
                            className="karanda-input karanda-input-small"
                            style={{ textAlign: "right" }}
                            value={i.pesoTotal / i.existencia}
                            customInput={Form.Control}
                            thousandSeparator="."
                            decimalSeparator="," 
                            decimalScale={2}
                            allowNegative={false}
                            onValueChange={(v) =>
                              handleChange(idx, "pesoProm", v.floatValue)
                            }
                          />
                        </td>
                        <td>
                          <NumericFormat
                            className="karanda-input karanda-input-small"
                            style={{ textAlign: "right" }}
                            value={i.pesoTotal}
                            customInput={Form.Control}
                            thousandSeparator="."
                            decimalSeparator="," 
                            decimalScale={2}
                            allowNegative={false}
                            onValueChange={(v) =>
                              handleChange(idx, "pesoTotal", v.floatValue)
                            }
                          />
                        </td>
                      </tr>
                    ))}
                    <tr style={{ fontWeight: "bold" }}>
                      <td>TOTAL</td>
                      <td>{previewTotals.cantidad}</td>
                      <td>{format(previewPromedio, 2)}</td>
                      <td>{format(previewTotals.peso, 2)}</td>
                    </tr>
                  </tbody>
                </Table>
                    <div style={{ textAlign: "right", marginTop: "15px" }}>
                      <Button
                        className="karanda-btn"
                        onClick={confirmSnapshot}
                        disabled={confirmLoading}
                      >
                        {confirmLoading ? (
                          <span>Cargando...</span>
                        ) : (
                          <span>Confirmar</span>
                        )}
                      </Button>
                    </div>
                  </>
                ) : (
                  <span>No hay registros</span>
                )
              ) : (
                <Table
                  bordered
                  hover
                  responsive
                  className="karanda-table"
                >
                  <thead>
                    <tr>
                      <th>Categoría</th>
                      <th>Cantidad</th>
                      <th>Peso prom.</th>
                      <th>Peso total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inventory.map((i, idx) => (
                      <tr key={idx}>
                        <td>{i.categoria?.nombre + (i.carimbo ? ' CO' + i.carimbo : '')}</td>
                        <td>{i.cantidad}</td>
                        <td>{format(i.pesoTotal / i.cantidad, 2)}</td>
                        <td>{format(i.pesoTotal, 2)}</td>
                      </tr>
                    ))}
                    <tr style={{ fontWeight: "bold" }}>
                      <td>Total</td>
                      <td>{inventoryTotals.cantidad}</td>
                      <td>{format(inventoryPromedio, 2)}</td>
                      <td>{format(inventoryTotals.peso, 2)}</td>
                    </tr>
                  </tbody>
                </Table>
              )}
            </section>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default InventarioInicial;
